import { LocationState } from 'services/api';
import { AutocompleteOption } from 'src/components/Autocomplete/types';
import * as yup from 'yup';

export enum FieldError {
  Name = 'Name is required.',
  Street = 'Address is required.',
  UnitNumber = 'Floor is required.'
}

export const LocationValidationSchema = yup.object({
  name: yup.string().required(FieldError.Name),
  street_and_building: yup.string().required(FieldError.Street),
  unit_number: yup.string().required(FieldError.UnitNumber),
  city: yup.string(),
  zipcode: yup.string(),
  building: yup.string().default(''),
  address_other: yup.string().default(''),
  delivery_instructions: yup.string().default(''),
  state: yup.mixed<LocationState>().oneOf(Object.values(LocationState)),
  geolocatorStreet: yup.mixed<AutocompleteOption>()
});

export type LocationFormValues = yup.InferType<typeof LocationValidationSchema>;
